import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui/styles/index';

interface NaviColors {
  $offBgColor: string;
  $onBgColor: string;
  $offTextColor: string;
  $onTextColor: string;
}

interface StyledNaviProps {
  $colors: NaviColors;
}

export const EvtNaviItemType2 = styled.div<StyledNaviProps>`
  ${mixin.flex({ align: 'center' })}
  flex: 1;
  position: relative;
  min-width: fit-content;
  height: 44px;
  white-space: nowrap;

  &.active {
    .area-click {
      background-color: ${({ $colors }) => $colors.$onBgColor};
    }

    .text-box {
      color: ${({ $colors }) => $colors.$onTextColor};
    }
  }

  .area-click {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 20px;
    background-color: ${({ $colors }) => $colors.$offBgColor};
    z-index: 1;

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 1px;
      height: 16px;
      background: rgba(174, 174, 174, 0.4);
      transform: translateY(-50%);
      z-index: 1;
    }

    span {
      font-family: 'Pretendard Variable', Pretendard, -apple-system,
        BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
        'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
        'Segoe UI Symbol', sans-serif;
    }
  }

  .text-box {
    ${mixin.flex({})}
    color: ${({ $colors }) => $colors.$offTextColor};

    .text {
      line-height: 128.571%;
      font-weight: 600;
      font-size: 14px;
    }
  }

  &:first-child .area-click:after,
  &.active + .event-navi-item .area-click:after,
  &.active .area-click:after {
    display: none;
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('44')};

    .area-click {
      padding: ${mixin.pxToVw('0 20')};

      &:after {
        height: ${mixin.pxToVw('16')};
      }
    }

    .text-box {
      .text {
        font-size: ${mixin.pxToVw('14')};
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    height: 72px;

    .area-click {
      padding: 0 40px;

      &:hover {
        background-color: ${({ $colors }) => $colors.$onBgColor};

        .text-box {
          color: ${({ $colors }) => $colors.$onTextColor};
        }
      }
    }

    .text-box {
      .text {
        line-height: 130%;
        font-size: 20px;
      }
    }

    .area-click:hover:after {
      display: none;
    }
  }
`;
